import React, { useState } from "react";
import "./uploadmodal.css";
import { endpoints } from "../../../services/endpoint";
import { axiosInstance } from "../../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Button,
  IconButton,
  Typography,
  Grid,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { CheckCircle, ErrorOutline } from "@mui/icons-material";

function UploadFileModal({ closeModal, onClose, onProfileAdded }) {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileKey, setFileKey] = useState("");
  
  const accountNo = localStorage.getItem("selectedAccountNo");
  const ID = localStorage.getItem("selectedID");
  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
   const EncryptedInstanceId=localStorage.getItem("EncryptedId")
  const username = localStorage.getItem("username")
 const email = localStorage.getItem("Email");
  const [uploadStatus, setUploadStatus] = useState({
    loading: false,
    success: false,
    error: false,
    message: "",
  });

  const [responseData, setResponseData] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setUploadStatus({
      loading: false,
      success: false,
      error: false,
      message: "",
    });
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      setUploadStatus({
        loading: false,
        success: false,
        error: true,
        message: "Please select a CSV file to upload.",
      });
      return;
    }

    setUploadStatus({
      loading: true,
      success: false,
      error: false,
      message: "Uploading file...",
    });

    const headers = {
      "Content-Type": "application/csv",
    };

    try {
      const csvContent = await selectedFile.text();

      const response = await axiosInstance.post(
        endpoints.upload.s3Upload,
        csvContent,
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        const parsedBody = JSON.parse(response.data.body);
        const fileKey = parsedBody.file; // Extract only the filename like "ZU69RF2VSA.csv"
        setFileKey(fileKey);

        // Proceed with bulk upload
        await handleBulkUpload(fileKey);
      } else {
        throw new Error("File upload failed");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadStatus({
        loading: false,
        success: false,
        error: true,
        message:
          error.response?.data?.message ||
          "Error uploading file. Please try again.",
      });
    }
  };
// const handleFileUpload = async () => {
//   if (!selectedFile) {
//     setUploadStatus({
//       loading: false,
//       success: false,
//       error: true,
//       message: "Please select a CSV file to upload.",
//     });
//     return;
//   }

//   setUploadStatus({
//     loading: true,
//     success: false,
//     error: false,
//     message: "Uploading file...",
//   });

//   const headers = {
//     "Content-Type": "application/json", // ✅ fix: send JSON
//   };

//   try {
//     const csvContent = await selectedFile.text();

//     // ✅ wrap CSV string inside JSON
//     const payload = {
//       fileName: selectedFile.name,
//       fileContent: csvContent,
//     };

//     const response = await axiosInstance.post(
//       endpoints.upload.s3Upload,
//       payload,
//       { headers }
//     );

//     if (response.status === 200) {
//       const parsedBody = JSON.parse(response.data.body);
//       const fileKey = parsedBody.file; // e.g. "ZU69RF2VSA.csv"
//       setFileKey(fileKey);

//       // Proceed with bulk upload
//       await handleBulkUpload(fileKey);

//       setUploadStatus({
//         loading: false,
//         success: true,
//         error: false,
//         message: "File uploaded successfully.",
//       });
//     } else {
//       throw new Error("File upload failed");
//     }
//   } catch (error) {
//     console.error("Error uploading file:", error);
//     setUploadStatus({
//       loading: false,
//       success: false,
//       error: true,
//       message:
//         error.response?.data?.message ||
//         "Error uploading file. Please try again.",
//     });
//   }
// };

  const fetchUsers = async () => {
    const payload = {
      ID:EncryptedInstanceId,
      awsAccount: customerAWSAccountId,
      region: region,
      InstanceAlias: instanceAlias,
      UserName:username,
      Email:email,
    };

    try {
      const response = await axiosInstance.post(
        endpoints.userList.listusers,
        payload
      );

      console.log("Response Data:", response.data);

      if (response.data && Array.isArray(response.data)) {
        const extractedData = response.data.map((item) => ({
          Login: item.Login,
          FullName: item.FullName,
          RoutingProfile: item.RoutingProfile,
          ACWTimeout: item.ACWTimeout,
          FirstName: item.FirstName,
          LastName: item.LastName,
          Email: item.Email,
          SecondaryEmail: item.SecondaryEmail,
          ARN: item.ARN,
          AutoAccept: item.AutoAccept,
          DeskPhone: item.DeskPhone,
          PhoneType: item.PhoneType,
          SecurityProfiles: item.SecurityProfiles,
          Tags: item.Tags,
        }));

        console.log("Extracted User Data:", extractedData);
        return extractedData;
      } else {
        console.warn("Unexpected response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  };

  const handleBulkUpload = async (fileKey) => {
    setUploadStatus({
      loading: true,
      success: false,
      error: false,
      message: "Processing bulk upload...",
    });

    try {
      // Step 1: Bulk Upload
      const bulkResponse = await axiosInstance.post(
        endpoints.bulk.BulkCsvUpload,
        {
          fileKey: `${fileKey}`,
          ID:EncryptedInstanceId,
          awsAccount: customerAWSAccountId,
          InstanceAlias: instanceAlias,
          region,
          Email:email,
          UserName:username,
          accessurl: "https://sravani-connectgen.my.connect.aws",
        }
      );

      console.log("Bulk upload response:", bulkResponse);
      console.log("Response status:", bulkResponse.status);
      console.log("Response data:", bulkResponse.data);

      // Check HTTP status first
      if (bulkResponse.status !== 200) {
        throw new Error(`HTTP Error: ${bulkResponse.status} - ${bulkResponse.statusText}`);
      }

      // If your API returns a statusCode in the response body, check that too
      if (bulkResponse?.data?.statusCode && bulkResponse.data.statusCode !== 200) {
        throw new Error(
          bulkResponse?.data?.body?.message ||
          bulkResponse?.data?.message ||
          "Bulk upload failed - API returned error status"
        );
      }

      // Update status to show fetching users
      setUploadStatus({
        loading: true,
        success: false,
        error: false,
        message: "Upload successful, fetching updated user list...",
      });

      // Step 2: Wait briefly to allow backend processing
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Step 3: Fetch updated user list
      const updatedList = await fetchUsers();

      if (updatedList && updatedList.length >= 0) {
        // Step 4: Update parent component with new user list
      if (typeof onProfileAdded === "function") {
  onProfileAdded(updatedList);
}


        setUploadStatus({
          loading: false,
          success: true,
          error: false,
          message: "Users created and fetched successfully!",
        });

        // Step 5: Close modal after successful update
        setTimeout(() => {
          onClose();
        }, 1500); // Give user time to see success message
      } else {
        throw new Error("Failed to fetch updated user list");
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      setUploadStatus({
        loading: false,
        success: false,
        error: true,
        message:
          error.response?.data?.message ||
          error.message ||
          "Upload process failed. Please try again.",
      });
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    closeModal();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Upload File</h3>
        </div>
        <div className="modal-line"></div>

        <ul className="modal-instructions">
          <li>1. File must be in .csv format.</li>
          <li>2. Each upload must contain more than one user.</li>
          <li>3. Each upload can contain a maximum of 1000 users.</li>
          <li>4. Each line holds comma-separated fields.</li>
          <li>5. Header line must be the same as the line in the given template.</li>
          <li>6. Field formats are indicated in the header.</li>
          <li>7. Must not contain duplicate user name.</li>
          <li>8. All fields are case sensitive.</li>
          <li>9. Ensure uploaded files do not contain formulas or commands.</li>
        </ul>

        <div className="modal-line"></div>

        {!selectedFile ? (
          <div className="button-group">
            <button className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button className="choose-file-button">
              <label>
                Choose File
                <input
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </label>
            </button>
          </div>
        ) : (
          <>
            <div className="selected-file-info">
              <p>
                <b>Selected file:</b>{" "}
                <span className="file-name">{selectedFile.name}</span>
              </p>
            </div>

            <div className="button-group">
              <button className="cancel-button" onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="upload-button-form"
                onClick={handleFileUpload}
                disabled={uploadStatus.loading}
              >
                {uploadStatus.loading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  "Upload File"
                )}
              </button>
            </div>
          </>
        )}

        <Snackbar
          open={uploadStatus.error || uploadStatus.success}
          autoHideDuration={6000}
          onClose={() =>
            setUploadStatus((prev) => ({
              ...prev,
              error: false,
              success: false,
            }))
          }
          message={uploadStatus.message}
        />
      </div>
    </div>
  );
}

export default UploadFileModal;